import styled from "styled-components";

import { SWReactCountryIcons } from "@similarweb/icons";
import { mixins } from "@similarweb/styles";
import { MultiSelectCountryDropdownItem } from "@similarweb/ui-components";

export const StyledMultiSelectCountryDropdownItem = styled(MultiSelectCountryDropdownItem)`
    span:not(.CountryCodeIcon-code) {
        ${mixins.setFontVariant("input2")};
    }

    ${SWReactCountryIcons} {
        height: 22px;
        width: 22px;
    }
`;
